module.exports = __webpack_public_path__ + "static/media/gaming5.8f020412.webp";